import React from "react";
import Text, { TextVariant } from "@/components/ui/text";
import { convertCurrency } from "@/pages/deals/helpers";
import { isNumber } from "lodash";

interface Props {
  amount: number | null | undefined;
  rate: number | undefined;
  accountCurrencySymbol: string;
  variant?: TextVariant;
}

const ConvertedCurrency: React.FC<Props> = ({
  amount,
  rate,
  accountCurrencySymbol,
  variant = "bodySecondary"
}) => {
  if (rate && isNumber(amount)) {
    const convertedAmount = convertCurrency(rate, amount);
    return (
      <Text
        variant={variant}
      >{`(${accountCurrencySymbol}${convertedAmount})`}</Text>
    );
  }
};

export default ConvertedCurrency;
